export function StatusBadge({ status }) {
  const map = {
    paid: "bg-green-50 text-green-700 border-green-200 dark:bg-green-950/40 dark:text-green-400 dark:border-green-900",
    pending: "bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-950/40 dark:text-amber-400 dark:border-amber-900",
    overdue: "bg-red-50 text-red-700 border-red-200 dark:bg-red-950/40 dark:text-red-400 dark:border-red-900",
  };
  const dot = { paid: "bg-green-500", pending: "bg-amber-500", overdue: "bg-red-500" };
  return (
    <span
      data-testid="invoice-status-badge"
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium capitalize ${map[status] || map.pending}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${dot[status] || dot.pending}`} />
      {status}
    </span>
  );
}
